import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';

import { SupplierMessage } from '../../../../types/SupplierMessage';
import { FormikCreateEnquiryValues } from '../../create-enquiry/CreateEnquiryFlow';

export function useUpdateSupplierDefaults(
    suppliers: SupplierMessage[],
    defaultSupplierId?: string,
    receiverSupplierIds?: string[]
) {
    const supplierIds = suppliers.map((supplier) => supplier.id);
    const [suppliersState, setSuppliersState] = useState<SupplierMessage[]>([]);

    const { setFieldValue, setFieldTouched, touched } = useFormikContext<FormikCreateEnquiryValues>();

    const newDefaultSupplierId = defaultSupplierId
        ? supplierIds.includes(defaultSupplierId)
            ? defaultSupplierId
            : undefined
        : undefined;

    useEffect(() => {
        const differentSuppliers = JSON.stringify(suppliersState) !== JSON.stringify(suppliers);

        // List of suppliers has changed (initial or if vessel of different customer is selected)
        if (differentSuppliers) {
            setSuppliersState(suppliers);
            setFieldValue('assignedSupplierIds', supplierIds, false);
            setFieldValue('assignedSuppliers', suppliers, false);

            // Remove supplier from receiver list if not in new list
            if (receiverSupplierIds?.length && touched.receiverSupplierIds) {
                const newReceiverSupplierIds = receiverSupplierIds.filter((id) => supplierIds.includes(id));

                // Preselect remaining receiver suppliers
                if (newReceiverSupplierIds.length > 1 && newReceiverSupplierIds.length !== receiverSupplierIds.length) {
                    setFieldValue('receiverSupplierIds', newReceiverSupplierIds, false);
                    setFieldTouched('receiverSupplierIds', true, false);
                }

                // Set default supplier if no receiver supplier is left
                if (newReceiverSupplierIds.length === 0 && newDefaultSupplierId) {
                    setFieldValue('receiverSupplierIds', [newDefaultSupplierId], false);
                }
            } else {
                // Set default supplier if no receiver supplier is set
                if (newDefaultSupplierId && !touched.receiverSupplierIds) {
                    setFieldValue('receiverSupplierIds', [newDefaultSupplierId], false);
                    setFieldTouched('receiverSupplierIds', false, false);
                }
            }
        }
    }, [
        suppliersState,
        setSuppliersState,
        setFieldValue,
        setFieldTouched,
        suppliers,
        supplierIds,
        receiverSupplierIds,
        newDefaultSupplierId,
        touched.receiverSupplierIds,
    ]);
}
